var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReverseDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9686_1893",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9686_1893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.175 16.0001H3C2.71667 16.0001 2.47917 15.9043 2.2875 15.7126C2.09583 15.5209 2 15.2834 2 15.0001C2 14.7168 2.09583 14.4793 2.2875 14.2876C2.47917 14.0959 2.71667 14.0001 3 14.0001H9.175L7.3 12.1251C7.11667 11.9418 7.025 11.7126 7.025 11.4376C7.025 11.1626 7.11667 10.9251 7.3 10.7251C7.5 10.5251 7.7375 10.4251 8.0125 10.4251C8.2875 10.4251 8.525 10.5251 8.725 10.7251L12.3 14.3001C12.4 14.4001 12.4708 14.5084 12.5125 14.6251C12.5542 14.7418 12.575 14.8668 12.575 15.0001C12.575 15.1334 12.5542 15.2584 12.5125 15.3751C12.4708 15.4918 12.4 15.6001 12.3 15.7001L8.7 19.3001C8.5 19.5001 8.26667 19.5959 8 19.5876C7.73333 19.5793 7.5 19.4751 7.3 19.2751C7.11667 19.0751 7.02083 18.8418 7.0125 18.5751C7.00417 18.3084 7.1 18.0751 7.3 17.8751L9.175 16.0001ZM14.825 10.0001L16.7 11.8751C16.8833 12.0584 16.975 12.2876 16.975 12.5626C16.975 12.8376 16.8833 13.0751 16.7 13.2751C16.5 13.4751 16.2625 13.5751 15.9875 13.5751C15.7125 13.5751 15.475 13.4751 15.275 13.2751L11.7 9.70011C11.6 9.60011 11.5292 9.49178 11.4875 9.37511C11.4458 9.25844 11.425 9.13344 11.425 9.00011C11.425 8.86678 11.4458 8.74178 11.4875 8.62511C11.5292 8.50844 11.6 8.40011 11.7 8.30011L15.3 4.70011C15.5 4.50011 15.7333 4.40428 16 4.41261C16.2667 4.42094 16.5 4.52511 16.7 4.72511C16.8833 4.92511 16.9792 5.15844 16.9875 5.42511C16.9958 5.69178 16.9 5.92511 16.7 6.12511L14.825 8.00011H21C21.2833 8.00011 21.5208 8.09594 21.7125 8.28761C21.9042 8.47928 22 8.71678 22 9.00011C22 9.28344 21.9042 9.52094 21.7125 9.71261C21.5208 9.90428 21.2833 10.0001 21 10.0001H14.825Z",
    fill: "#175C8E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverseDestination);
export default __webpack_public_path__ + "static/media/reverse-destination.ad740859791d7bc1547da646df29a632.svg";
export { ForwardRef as ReactComponent };